/**
 * Created by asiulik on 20.11.2017.
 */

define(['jquery', 'lodash'], function($, _){

    function Login() {}

    Login.prototype.init = function(){

        var re = new RegExp("userName=([^;]+)");
        var cookieUserName = re.exec(document.cookie);
        cookieUserName = (cookieUserName != null) ? decodeURIComponent(cookieUserName[1]).replace('+', ' ') : null;

        if (cookieUserName) {
            $('.logged-username').text($.trim(cookieUserName));
        }

    };


    return Login;


});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/login.js